import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';
import { getOptions } from '@ourbranch/lookups';

import BaseDialog from 'core/components/base-dialog';
import { Label } from 'core/components/label';
import { Button } from 'core/components/button';
import { FormField } from 'core/components/form';
import useStyles from './quote-source-modal.styles';

const leadSourceOptions = getOptions('leadSources');

// Mount point for the Quote source modal (#36365), which restyles it to the design. Until then it
// shows the Billing tab's lead source and affinity code fields. They're offer form fields, so a
// change is held until the quote is updated, as on the Billing tab.
const QuoteSourceModal = ({ open, onClose }) => {
  const classes = useStyles();
  return (
    <BaseDialog open={open} onClose={onClose} size="sm" fullWidth>
      <Label type="greenBig" className={classes.title}>
        Quote source
      </Label>
      <Grid container spacing={4}>
        <FormField
          label="Lead source"
          xs={12}
          type="select"
          name="leadSource"
          options={leadSourceOptions}
          mode="light"
        />
        <FormField label="Affinity code" xs={12} type="affinity" name="global.affinity" mode="light" fast={false} />
      </Grid>
      <div className={classes.actions}>
        <Button variant="contained" color="primary" onClick={onClose}>
          Done
        </Button>
      </div>
    </BaseDialog>
  );
};

QuoteSourceModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default QuoteSourceModal;
